import React from 'react';
import {
  Create,
  TextInput,
  BooleanInput,
  DateInput,
  SelectInput,
  ReferenceInput,
  TabbedForm,
  FormTab,
  required,
  useTranslate,
} from 'react-admin';
import { Grid } from '@mui/material';

const experienceRadiusChoices = [
  { id: 'LOCAL', name: 'Local' },
  { id: 'REGIONAL', name: 'Regional' },
  { id: 'LONG_HAUL', name: 'Long Haul' },
];

export const DriverCreate = () => {
  const translate = useTranslate();

  return (
    <Create>
      <TabbedForm>
        <FormTab label={translate('user.driver.details.operating_details')}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <ReferenceInput source="userId" reference="users">
                <SelectInput optionText="name" validate={required()} fullWidth />
              </ReferenceInput>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextInput
                source="profileState"
                label={translate('resources.drivers.fields.profileState')}
                fullWidth
              />
            </Grid>
          </Grid>
        </FormTab>

        <FormTab label="Experience">
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <BooleanInput
                source="hasCanadaExperience"
                label={translate('user.driver.details.canada_exp.label')}
              />
              <TextInput source="canadaExperience" multiline rows={3} fullWidth />
            </Grid>
            <Grid item xs={12} md={4}>
              <BooleanInput
                source="hasUsaExperience"
                label={translate('user.driver.details.usa_exp.label')}
              />
              <TextInput source="usaExperience" multiline rows={3} fullWidth />
            </Grid>
            <Grid item xs={12} md={4}>
              <BooleanInput
                source="hasInternationalExperience"
                label={translate('user.driver.details.international_exp.label')}
              />
              <TextInput source="internationalExperience" multiline rows={3} fullWidth />
            </Grid>
            <Grid item xs={12}>
              <SelectInput
                source="experienceRadius"
                label={translate('user.driver.details.radius.label')}
                choices={experienceRadiusChoices}
                fullWidth
              />
            </Grid>
          </Grid>
        </FormTab>

        <FormTab label="Safety">
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <BooleanInput
                source="hasRecentAccident"
                label={translate('user.driver.details.accident.label')}
              />
              <TextInput source="recentAccidentDescription" multiline rows={3} fullWidth />
            </Grid>
            <Grid item xs={12} md={6}>
              <BooleanInput
                source="hasRecentTicket"
                label={translate('user.driver.details.recent_ticket.label')}
              />
              <TextInput source="recentTicketDescription" multiline rows={3} fullWidth />
            </Grid>
            <Grid item xs={12}>
              <BooleanInput
                source="drugAlcohol3Year"
                label={translate('user.driver.details.drug_alcohol_testing.label')}
              />
            </Grid>
          </Grid>
        </FormTab>

        <FormTab label="Citizenship & Work Auth">
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <BooleanInput
                source="canadianCitizen"
                label={translate('user.driver.details.can_citizen.label')}
              />
              <BooleanInput
                source="canadaLiveAndWork"
                label={translate('user.driver.details.can_employment_eligible.label')}
              />
              <BooleanInput
                source="canEnterUsa"
                label={translate('user.driver.details.us_entry_status.label')}
              />
              <BooleanInput
                source="usaDenied"
                label={translate('user.driver.details.us_entry_check.label')}
              />
            </Grid>
          </Grid>
        </FormTab>

        <FormTab label="Travel Documents">
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <BooleanInput
                source="hasValidPassport"
                label={translate('user.driver.details.passport_check.label')}
              />
              <TextInput
                source="passportCountryOrigin"
                label={translate('user.driver.details.passport_origin.label')}
                fullWidth
              />
              <DateInput
                source="passportExpiry"
                label={translate('user.driver.details.passport_expiry.label')}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <BooleanInput
                source="hasFastPass"
                label={translate('user.driver.details.fastpass_check.label')}
              />
              <TextInput
                source="fastPassNumber"
                label={translate('user.driver.details.fastpass_number.label')}
                fullWidth
              />
              <BooleanInput
                source="hasUsDotNumber"
                label={translate('user.driver.details.usdot_check.label')}
              />
              <TextInput
                source="usDotNumber"
                label={translate('user.driver.details.usdot_number.label')}
                fullWidth
              />
            </Grid>
          </Grid>
        </FormTab>
      </TabbedForm>
    </Create>
  );
};
